import ServiceExec from '@/common/utils/ServiceExec';
/**
 * 뱅크다이어리 고객 센터 관련 API Service
 * @class ServiceSvc
 */
class ServiceSvc extends ServiceExec {
  /**
   *  이벤트, 공지사항 리스트 가져오기
   *  @param Authorization {string} Authorization
   *  @param limit {integer}
   *  @param page {integer}
   *  @param type {integer} 1: 이벤트, 2: 공지사항
   */
  getListBoxBoard(params = {}) {
    return this.get(`/api/expert/board`, params).then((response) => {
      return response.data;
    });
    // return this.get(`/api/expert/service/getListBoxMatching`, params).then(
    //   (response) => {
    //     return response.data
    //   }
    // )
  }

  /**
   *  게시물 상세 가져오기
   *  @param Authorization {string} Authorization
   *  @param boardNo {integer}
   */
  getMapBoard(params = {}) {
    return this.get(`/api/expert/board/${params.boardNo}`).then((response) => {
      return response.data;
    });
    // return this.get(`/api/expert/service/getMapBoard`, params).then((response) => {
    //   return response.data;
    // });
  }
}
export default new ServiceSvc();
